import { FeaturesManagement } from '../../featuresControl';
import { logger } from '../services/SharedService';
import useGetFleet from './useGetFleetDetails';
import useGetFleetId from './useGetFleetId';

type FleetFeatures = {
  liveVideo: boolean;
  videoRecording: boolean;
};

function useGetFleetFeatures(): FleetFeatures {
  const fleetId = useGetFleetId();

  const { data, status } = useGetFleet(fleetId as string);

  logger.info('Features status (fleet settings)', data?.features, status);

  return data?.features !== undefined && status === 'success' ? {
    liveVideo: data.features.videoStreaming && FeaturesManagement.features.videoStreaming,
    videoRecording: data.features.videoRecording && FeaturesManagement.features.videoRecording,
  } : {
    liveVideo: false,
    videoRecording: false,
  };
}

export default useGetFleetFeatures;
